export default "__VITE_ASSET__DKEPVU9E__"